import { createSelector } from '@reduxjs/toolkit'

import { selectDownload } from './selectDownload'

export const selectDownloadProgress = createSelector(selectDownload, (download) => ({
  loadedBytes: download.loadedBytes,
  totalBytes: download.totalBytes,
  remainingBytes: download.remainingBytes,
  percent: download.percent,
}))
